import { ErrorPage } from '~/components/ErrorPage';
import { useUser } from '~/modules/auth/hooks/useUser';

export function RequestSublabelPage() {
  const { hasPermission } = useUser();
  const canRequestLabel = hasPermission('LABEL_REQUEST.CREATE');

  if (!canRequestLabel) {
    return <ErrorPage type="noAccessPage" />;
  }

  return 'Sublabel request page placeholder';
}

RequestSublabelPage.displayName = 'RequestSublabelPage';
